import de from './locale/de';
import en from './locale/en';
import es from './locale/es';
import fr from './locale/fr';
import it from './locale/it';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';

export default {
  de,
  en,
  es,
  fr,
  it,
  pt,
  pt_BR,
};
